<template>
   <div class="bigBox">
    <div class="Title" > <el-button @click="backbtn" style="font-size: 22px; font-weight: 700; color: black;" type="text"> 返回 | 编辑</el-button></div>
     <div class="formBox">
        <el-form  :label-position="labelPosition" label-width="150px" ref="form" :model="Dform" :rules="rules">
          <el-form-item  prop="name" label="任务名称">
              <el-input  v-model="Dform.name"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item  prop="checkUserType" label="考核对象">
            <el-select v-model="Dform.checkUserType"  placeholder="请选择">
                    <el-option v-for="item in PeopleObj" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-row :gutter="20">
        <el-col :span="10">
        <el-form-item  prop="checkPeriodType" label="考核周期">
            <el-select v-model="Dform.checkPeriodType"  placeholder="请选择">
                    <el-option v-for="item in period" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="10" v-if="Dform.checkPeriodType == 'semester'">
            <el-form-item   label="" label-width="50px">
                <el-date-picker
                    v-model="timeData"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="pickerChangeFn"
                    >
               </el-date-picker>
        </el-form-item>
        </el-col>
        </el-row>
        <el-form-item  prop="approveUserType" label="考核人">
            <el-select v-model="Dform.approveUserType"  placeholder="请选择">
                    <el-option v-for="item in peopleAll" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>

        <el-row :gutter="20">
        <el-col :span="10">
            <el-form-item   label="初始分值">
              <el-input  v-model="Dform.initialSore"  autocomplete="off"></el-input>
        </el-form-item>
        
        </el-col>
        <el-col :span="10" >
            <el-form-item   label="" label-width="70px">
                <el-checkbox v-model="Dform.initialScoreRanking">初始分值加入排名</el-checkbox>
            </el-form-item>
        </el-col>
        </el-row>

        <el-row :gutter="20">
        <el-col :span="10">
         <el-form-item   label="累计得分上限">
            <el-select v-model="Dform.shangxian"  placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
            
        </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item   label="" label-width="70px">
              <el-input  v-model="Dform.scoreUpLimit"  autocomplete="off" :disabled="Dform.shangxian == 2?true:false"></el-input>
        </el-form-item>
        </el-col>
        </el-row>

        <el-row :gutter="20">
        <el-col :span="10">
         <el-form-item   label="累计得分下限">
            <el-select v-model="Dform.xiaxian"  placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
         </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item   label="" label-width="70px">
              <el-input  v-model="Dform.scoreDownLimit"  autocomplete="off" :disabled="Dform.xiaxian == 2?true:false"></el-input>
        </el-form-item>
        </el-col>
        </el-row>

        <el-row :gutter="20">
        <el-col :span="10">
            <el-form-item   label="考试频次">
            <el-select v-model="Dform.checkFrequency"  placeholder="请选择">
                    <el-option v-for="item in pingci" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item   label="" label-width="70px">
              <el-input  v-model="Dform.checkFrequencyCount"  autocomplete="off"></el-input>
        </el-form-item>
        </el-col>
        </el-row>
            <div class="buttom-box">
                    <el-button type="primary" @click="submitForm('form')" :loading="loading">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
            </div>
    </el-form>
     </div>
     <div class="tableBox">
        <div class="tableTiele"><span style="font-weight: 700; font-size: 16px">考核项</span> <el-button type="text" @click="ItenAdd('添加')">添加</el-button></div>
        <el-row class="list">
         <el-table
         :border="true"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          style="width: 100%"
         :data="tableData"
        
         >
          <el-table-column
            prop="name"
            label="考核项名称"
            >
          </el-table-column>
            <el-table-column
            prop="addScoreType"
            label='分值录入方式'
            >
            <template #default="scope">
                {{ scope.row.addScoreType==1? '固定选项':'手动输入' }}
            </template>
          </el-table-column>
          <el-table-column
            label="打分标准/得分"
            >
            <template #default="scope">
            <div v-if="scope.row.addScoreType=='1'" v-for="item in scope.row.checkScoreStandards"> 
                {{ item.scoreStandard+'（' + item.score +'）' }} 
            </div>
            <div v-if="scope.row.addScoreType=='0'" v-for="item in scope.row.checkScoreStandards"> 
                {{ item.scoreStandard }} 
            </div>
            </template>
          </el-table-column>
          
          <el-table-column
            prop="lat1"
            label="单次打分范围"
            >
            <template #default="scope">
            <div v-if="scope.row.addScoreType=='1'"> 
                
            </div>
            <div v-for="item in scope.row.checkScoreStandards"> 
                {{  item.lowestScore!=null? item.lowestScore : ''  }} 
                <span v-if=" item.highestScore!=null&&item.lowestScore!=null " > - </span>
                {{ item.highestScore!=null? item.highestScore :''  }}
            </div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            >
            <template #default="scope">
              <el-button class="shanchuBtn" type="text" size="small" @click="ItenAdd('编辑',scope.row)" >编辑</el-button>
              <el-button class="shanchuBtn" type="text" size="small" @click="deleteClick(scope.row)" >删除</el-button>

            </template>
          </el-table-column>
          
        </el-table>
      </el-row>
     </div>
     <ItemAd v-if="showItem" :ItemInfoobj='ItemInfoobj' :addItem="addItem" :addtilie="addtilie" @backBtnAd="backBtnAd"></ItemAd>
   </div>
</template>
<script>
import { AddTaskUpdate,CheckTaskList,checkItemDeletet} from '@/assets/api/deyu.js'
import { ElMessage } from 'element-plus'
import ItemAd from './itemAd.vue';

export default {
   name: '',
   components: {
    ItemAd
   },
   props: ['Infoobj'],
   data() {
    return {
        dialogVisible: true,
        labelPosition:'left',
        loading:false,
        showItem:false,
        title:'',
        Dform:{
                name:'',
                checkUserType:'',
                checkPeriodType:'',
                approveUserType:'',
                initialSore:'',
                scoreUpLimit:'',
                scoreDownLimit:'',
                checkFrequency:'',
                checkFrequencyCount:'',
                initialScoreRanking:'',

                // -----------
                xiaxian:'',
                shangxian:"",
                
            },
            timeData:[],
            checkEndTime:"",
            checkStartTime:"",
        tableData:[],
        rules: {
            name: [
                { required: true, message: '请输入考核名称', trigger: 'change' },
                ],
            checkUserType: [
                { required: true, message: '请选择考核对象', trigger: 'change' }
            ],
            checkPeriodType: [
                { required: true, message: '请选择周期', trigger: 'change' }
            ],         
            approveUserType: [
                { required: true, message: '请选择考核人', trigger: 'change' }
            ],
            },
            peopleAll: [
                {
                    value: 'all',
                    label: '全员'
                }
            ],
            options: [
                {
                    value: '1',
                    label: '自定义'
                },
                {
                    value: '2',
                    label: '不限'
                }
            ],
            period:[
                {
                    value: 'day',
                    label: '天'
                }, {
                    value: 'week',
                    label: '周'
                },
                {
                    value: 'month',
                    label: '月'
                }, {
                    value: 'semester',
                    label: '学期'
                },
            ],
            PeopleObj: [
                {
                    value: 'student',
                    label: '学生'
                }, 
                {
                    value: 'class',
                    label: '班级'
                },
                {
                    value: 'teacher',
                    label: '教师'
                },
            
            ],
            pingci: [
               {
                    value: 'day',
                    label: '天'
                }, {
                    value: 'week',
                    label: '周'
                },
                {
                    value: 'month',
                    label: '月'
                },
                {
                    value: 'null',
                    label: '不限'
                },
            
            ],
            ItemInfoobj: {},
            addtilie:'',
            addItem: {}
        }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
        this.Dform.name = this.Infoobj.name
        this.Dform.checkUserType = this.Infoobj.checkUserType
        this.Dform.checkPeriodType = this.Infoobj.checkPeriodType
            // this.checkStartTime = String(this.Infoobj.checkStartTime)
            // this.checkEndTime = String(this.Infoobj.checkEndTime)
        this.Dform.approveUserType = this.Infoobj.approveUserType
        this.Dform.initialSore = this.Infoobj.initialSore
        this.Dform.scoreUpLimit = this.Infoobj.scoreUpLimit
        this.Dform.scoreDownLimit = this.Infoobj.scoreDownLimit
        this.Dform.checkFrequency = this.Infoobj.checkFrequency
        this.Dform.checkFrequencyCount = this.Infoobj.checkFrequencyCount
        this.Dform.initialScoreRanking =this.Infoobj.initialScoreRanking ==1 ?true:false


        this.Dform.shangxian = this.Infoobj.scoreUpLimit != null?this.Dform.shangxian= '1':this.Dform.shangxian = '2'
        this.Dform.xiaxian = this.Infoobj.scoreDownLimit != null?this.Dform.xiaxian= '1':this.Dform.xiaxian = '2'

        // const arr = []
        this.timeData.push(this.Infoobj.checkStartTime, this.Infoobj.checkEndTime)
        this.ItemInfoobj = this.Infoobj

        
   },
   created(){
    this.GetChecklist()
   },
   methods: {
    deleteClick (item) {
         checkItemDeletet(item.id).then((res)=> {
            // this.tableData = res.data.data
            // this.loading = false
            this.GetChecklist()
        }).catch((err)=> {
            console.log(err);
        })
    },
    handleClose() {
               this.$emit('back')
          },
    backbtn(){
           this.handleClose()
           
       },
    //每一项添加
    ItenAdd(name,item){
        if ( name == '添加' ) {
            this.addtilie = '添加'
        } else if ( name == '编辑' ) {
            this.addtilie = '编辑'
            this.addItem = JSON.stringify(item) 
        }
        this.showItem = true
    },
    backBtnAd(){
        this.showItem = false
        this.GetChecklist()
    },
    // 考核项列表
    GetChecklist() {
        CheckTaskList(this.Infoobj.id).then((res)=> {
            this.tableData = res.data.data
            // this.loading = false
            console.log(res,'考核项列表');
        }).catch((err)=> {
            console.log(err);
        })
    },
    // 提交修改
    submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.addBtn()
            } else {
                return false;
            }
            });
        },
    //考核任务修改
    addBtn(){
        const params = {
            name:this.Dform.name,
            checkUserType:this.Dform.checkUserType,
            checkPeriodType:this.Dform.checkPeriodType,
            approveUserType:this.Dform.approveUserType,
            initialSore:this.Dform.initialSore,
            checkFrequency:this.Dform.checkFrequency,
            checkFrequencyCount:this.Dform.checkFrequencyCount,
            // scoreUpLimit:this.Dform.scoreUpLimit,
            // scoreDownLimit:this.Dform.scoreDownLimit,
            // checkStartTime:this.timeData[0],
            // checkEndTime:this.timeData[1],
            scoreUpLimit:this.Dform.shangxian == '2' ? null:this.Dform.scoreUpLimit,
            scoreDownLimit:this.Dform.xiaxian== '2' ? null:this.Dform.scoreDownLimit,
            checkStartTime:this.Dform.checkPeriodType != 'semester'? '': this.timeData[0],
            checkEndTime:this.Dform.checkPeriodType != 'semester'? '':this.timeData[1],
            id:this.Infoobj.id,
            initialScoreRanking:this.Dform.initialScoreRanking == true?1 :0


        }
        AddTaskUpdate(params).then((res) => {
            console.log(res,'x修改完成');
            ElMessage({message: '修改完成',type: 'success',})
            // this.handleClose()

            
        }).catch((err) => {
            // console.log(res,'新增失败');
            // ElMessage.error("修改失败")
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
             });


        })
        
    },
     
   }
};
</script>
<style  scoped lang="scss">
    .bigBox{
        // padding: 20px;
        height: 100%;
    }
    .Title{
        font-weight: 700;
        padding: 20px;
        


    }
    .formBox{
        padding: 0px 20px;
        width: 50%;
    }
    .tableBox{
        padding: 20px;
        overflow: auto;
        height: 35%;
        .tableTiele{
            margin-bottom: 10px
        }

    }
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 30px;
            line-height: 35px;
            text-align: center;
            // width: 280px;
        }
        .el-input__inner{
        width: 10px !important;
        }

    .el-input--small{
        width: 200px;
    }
    .el-select--small .el-select__wrapper {
            width: 200px;
            height: 30px;
        }
    // .el-form-item--small{
    //     width: 310px !important;
    //     // height: 20px;
    // }
    .el-form-item--small {
        width: 400px !important;
    }
    }
</style>